"use strict";

var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UsagePoint = exports.Child = exports.RelationType = exports.decodeUsagePoint = void 0;

var uuid_1 = require("./support/uuid");

var location_1 = require("./location");

var unit_1 = require("./unit");

var weather_1 = require("./weather");

var sla_1 = require("./sla");

var usage_point_1 = __importDefault(require("./http/usage_point"));

exports.decodeUsagePoint = function (u) {
  var uuid;

  if (typeof u.uuid === "string") {
    uuid = new uuid_1.UUID(u.uuid);
  } else {
    uuid = new uuid_1.UUID(u.uuid._uuid);
  }

  var usagePoint = new UsagePoint(uuid, u.assetid, u.giai, new Date(u.time), u.deviceType);

  if (u.location) {
    usagePoint.location = location_1.decodeLocation(u.location);
  }

  if (u.children) {
    usagePoint.children = decodeChildren(u.children);
  }

  if (u.weather) {
    usagePoint.weather = weather_1.decodeWeather(u.weather);
  }

  return usagePoint;
};

var RelationType;

(function (RelationType) {
  RelationType[RelationType["Unknown"] = 0] = "Unknown";
  RelationType[RelationType["None"] = 1] = "None";
  RelationType[RelationType["Integrated"] = 2] = "Integrated";
  RelationType[RelationType["Submeter"] = 3] = "Submeter";
  RelationType[RelationType["AtLocation"] = 4] = "AtLocation";
  RelationType[RelationType["Administrative"] = 5] = "Administrative";
  RelationType[RelationType["Routing"] = 6] = "Routing"; // This unit has a networking relationship to its parent (being routed by it)
})(RelationType = exports.RelationType || (exports.RelationType = {}));

;

var decodeChildren = function decodeChildren(children) {
  var e_1, _a;

  var ret = [];

  try {
    for (var children_1 = __values(children), children_1_1 = children_1.next(); !children_1_1.done; children_1_1 = children_1.next()) {
      var c = children_1_1.value;
      ret.push(new Child(unit_1.decodeUnit(c.unit), c.relationType, c.note));
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (children_1_1 && !children_1_1.done && (_a = children_1.return)) _a.call(children_1);
    } finally {
      if (e_1) throw e_1.error;
    }
  }

  return ret;
};

var Child =
/** @class */
function () {
  function Child(unit, relationType, note) {
    this.unit = unit;
    this.relationType = relationType;
    this.note = note;
  }

  return Child;
}();

exports.Child = Child;

var UsagePoint =
/** @class */
function () {
  /**
   * Create a new Unit
   * @param uuid - The UUID of the unit
   */
  function UsagePoint(uuid, assetid, giai, time, deviceType, location, children) {
    if (assetid === void 0) {
      assetid = '';
    }

    if (giai === void 0) {
      giai = '';
    }

    if (deviceType === void 0) {
      deviceType = 0;
    }

    var yearZero = new Date(); // Since dawn of time the fate of man is that of lice

    yearZero.setTime(0); // Equal as parasites and moving without eyes

    this.uuid = uuid;
    this.assetid = assetid;
    this.giai = giai;
    this.time = yearZero;

    if (time) {
      this.time = time;
    }

    this.deviceType = deviceType;
    this.lastUpdated = yearZero;
    this.location = new location_1.UnitLocation('', '', 0, 0, '', '', '', '', '', '', '', '', '');

    if (location) {
      this.location = location;
    }

    this.children = [];

    if (children) {
      this.children = children;
    }

    this.weather = new weather_1.Weather(yearZero, 0, '', 0, 0, 0, 0);
    this.connectable = false;
    this.fields = [];
    this.sla = new sla_1.SLA(0, 0);
  }
  /** Replace merges and updates storage for a given unit */


  UsagePoint.prototype.replace = function (u
  /*, store=true*/
  ) {
    this.merge(u); // if (store) { this.store(); }
  }; // transform ports into multiports

  /* Persistency related functions */

  /** Tries to load this unit from IndexedDB or whatever is available */

  /*load() {
    load(this.uuid).then((res) => {
      console.log("Loaded: "+this.uuid.string()+" from storage");
      this.merge(res);
    }).catch((reason) => {
      console.log("No such unit found in storage. Load failed with: "+reason);
    });
  }*/

  /** Store this unit in IndexedDB or whatever is available */


  UsagePoint.prototype.store = function () {};
  /* Remote access functions  */

  /** gets the unit with the given fields from the REST API */

  /**
   * Get gets the device from from the API if it exists. This returns a Promise for a Unit or undefined
   * @param fields - Fields is the set of fields used to query the backend
   * @param credentials Credentials holds the authorization credentials for the request
   *
   * @returns
   */


  UsagePoint.prototype.get = function (fields, credentials) {
    var _this = this;

    return usage_point_1.default(this.uuid, this.lastUpdated, fields, credentials).then(function (resp) {
      var up = exports.decodeUsagePoint(resp);

      _this.replace(up);

      _this.fields = fields; // should we merge these?

      return up;
    });
  };
  /* Support functions */

  /** Merges inputted unit with this unit in an as safe as possible manner */


  UsagePoint.prototype.merge = function (u) {
    if (!this.uuid.equals(u.uuid)) {
      throw Error("Merge called with mismatching unit. " + u.uuid.string() + " tried to merge with " + this.uuid.string());
    }

    this.assetid = u.assetid;
    this.giai = u.giai;
    this.time = u.time;
    this.deviceType = u.deviceType;
    this.location = u.location;
    this.weather = u.weather;
    this.connectable = u.connectable;

    if (u.children != null) {
      this.children = u.children;
    }
  };

  return UsagePoint;
}();

exports.UsagePoint = UsagePoint;